export default __webpack_public_path__ + "static/media/DSC07411.685564f4.jpg";